export const sequence_detail_steps_en = {
  sequence_workflow_condition_add: "New condition",
  sequence_detail_setting_credential_primary_flag: "Primary",
  sequence_detail_setting_credential_primary_opeator: "Set as primary",
  sequence_workflow_setting_panel_reply_thread: "Reply pre-thread",
  sequence_workflow_setting_panel_template_dialog_go_edit:
    "Edit in Template Source",
  sequence_workflow_setting_panel_edit_template_notic_dialog_title:
    "This Email is Linked to a Template",
  sequence_workflow_setting_panel_edit_template_notic_dialog_content_para:
    "This content is locked because it’s linked to a template, ensuring consistency across your sequences. To edit, you have two options:",
  sequence_workflow_setting_panel_edit_template_notic_dialog_content_li_1:
    "Edit the template – Updates will apply to all linked emails.",
  sequence_workflow_setting_panel_edit_template_notic_dialog_content_li_2:
    "Unlink this email – This allows direct edits, but it will no longer sync with the template.",
  sequence_workflow_setting_panel_unlink_template_dialog_submit_button:
    "Unlink & Edit",
  sequence_workflow_setting_panel_unlink_template_dialog_go_template_button:
    "Go to Template",
  sequence_template_aside_empty_description: "Noting here yet",
  version: "Version",
  sequence_workflow_template_dialog_refresh: "Refresh",
  sequence_workflow_template_dialog_use_template_button: "Use template",
  sequence_workflow_template_dialog_use_template_button_copy: "Copy and paste",
  sequence_workflow_template_dialog_use_template_button_link: "Link",
  sequence_workflow_template_blank: "Nothing here",
  sequence_workflow_setting_panel_template_dialog_title: "Templates",
  sequence_workflow_setting_panel_template_placeholder: "Select template",
  sequence_details_steps_canvas_new_version: "New version",
  sequence_workflow_delay_minute: "0 minutes | 1 minute | {count} minutes",
  sequence_workflow_delay_day: "0 days | 1 day | {count} days",
  sequence_workflow_delay_hour: "0 hours | 1 hour | {count} hours",
  json_editor_dialog_title: "JSON EDITOR",
  please_update_unvalidated_fields: "Please update unvalidated fields",

  sequence_workflow_condition_form_item_label_condition: "Condition",
  sequence_workflow_condition_form_item_label_node: "Node",
  sequence_workflow_condition_form_item_label_type: "Type",

  sequence_workflow_run_test_dialog_title: "Run Test",
  sequence_workflow_run_test_dialog_submit_button: "Run",
  sequence_workflow_run_test_dialog_targets: "Sequence Target",
  please_select_a_target: "Please select one target",
  run_test: "Run test",
};

export const sequence_detail_steps_zh_tw = {
  sequence_workflow_condition_add: "新增條件",
  sequence_detail_setting_credential_primary_flag: "主要",
  sequence_detail_setting_credential_primary_opeator: "設為主要",
  sequence_workflow_setting_panel_reply_thread: "回覆前一主題",
  sequence_workflow_setting_panel_template_dialog_go_edit: "在範本來源中編輯",
  sequence_workflow_setting_panel_edit_template_notic_dialog_title:
    "此電子郵件已連結至範本",
  sequence_workflow_setting_panel_edit_template_notic_dialog_content_para:
    "此內容已鎖定，因為它已連結到範本，以確保序列間的一致性。若要編輯，您有兩個選項：",
  sequence_workflow_setting_panel_edit_template_notic_dialog_content_li_1:
    "編輯範本 —— 更新將套用到所有已連結的電子郵件。",
  sequence_workflow_setting_panel_edit_template_notic_dialog_content_li_2:
    "取消連結此電子郵件 —— 可直接編輯，但將不再與範本同步。",
  sequence_workflow_setting_panel_unlink_template_dialog_submit_button:
    "取消連結並編輯",
  sequence_workflow_setting_panel_unlink_template_dialog_go_template_button:
    "前往範本",
  sequence_template_aside_empty_description: "這裡還沒有內容",
  version: "版本",
  sequence_workflow_template_dialog_refresh: "重新整理",
  sequence_workflow_template_dialog_use_template_button: "使用範本",
  sequence_workflow_template_dialog_use_template_button_copy: "複製並貼上",
  sequence_workflow_template_dialog_use_template_button_link: "連結",
  sequence_workflow_template_blank: "這裡還沒有內容",
  sequence_workflow_setting_panel_template_dialog_title: "範本",
  sequence_workflow_setting_panel_template_placeholder: "選擇範本",
  sequence_details_steps_canvas_new_version: "新版本",
  sequence_workflow_delay_minute: "0 分鐘 | 1 分鐘 | {count} 分鐘",
  sequence_workflow_delay_day: "0 天 | 1 天 | {count} 天",
  sequence_workflow_delay_hour: "0 小時 | 1 小時 | {count} 小時",
  json_editor_dialog_title: "JSON 編輯器",
  please_update_unvalidated_fields: "請更新未驗證的欄位",
  sequence_workflow_condition_form_item_label_condition: "條件",
  sequence_workflow_condition_form_item_label_node: "節點",
  sequence_workflow_condition_form_item_label_type: "類型",
  sequence_workflow_run_test_dialog_title: "執行測試",
  sequence_workflow_run_test_dialog_submit_button: "執行",
  sequence_workflow_run_test_dialog_targets: "序列目標",
  please_select_a_target: "請選擇一個目標",
  run_test: "運行測試",
};

export const sequence_detail_steps_zh_cn = {
  sequence_workflow_condition_add: "新增条件",
  sequence_detail_setting_credential_primary_flag: "主要",
  sequence_detail_setting_credential_primary_opeator: "设为主要",
  sequence_workflow_setting_panel_reply_thread: "回复前一主题",
  sequence_workflow_setting_panel_template_dialog_go_edit: "在模板来源中编辑",
  sequence_workflow_setting_panel_edit_template_notic_dialog_title:
    "该邮件已链接至模板",
  sequence_workflow_setting_panel_edit_template_notic_dialog_content_para:
    "该内容已被锁定，因为它链接了模板，以保证各个序列内容一致。若需编辑，您有两个选项：",
  sequence_workflow_setting_panel_edit_template_notic_dialog_content_li_1:
    "编辑模板 —— 更新将应用到所有已链接的邮件。",
  sequence_workflow_setting_panel_edit_template_notic_dialog_content_li_2:
    "取消链接该邮件 —— 可直接编辑，但将不再与模板同步。",
  sequence_workflow_setting_panel_unlink_template_dialog_submit_button:
    "取消链接并编辑",
  sequence_workflow_setting_panel_unlink_template_dialog_go_template_button:
    "前往模板",
  sequence_template_aside_empty_description: "这里还没有内容",
  version: "版本",
  sequence_workflow_template_dialog_refresh: "刷新",
  sequence_workflow_template_dialog_use_template_button: "使用模板",
  sequence_workflow_template_dialog_use_template_button_copy: "复制粘贴",
  sequence_workflow_template_dialog_use_template_button_link: "链接",
  sequence_workflow_template_blank: "这里还没有内容",
  sequence_workflow_setting_panel_template_dialog_title: "模板",
  sequence_workflow_setting_panel_template_placeholder: "选择模板",
  sequence_details_steps_canvas_new_version: "新版本",
  sequence_workflow_delay_minute: "0 分钟 | 1 分钟 | {count} 分钟",
  sequence_workflow_delay_day: "0 天 | 1 天 | {count} 天",
  sequence_workflow_delay_hour: "0 小时 | 1 小时 | {count} 小时",
  json_editor_dialog_title: "JSON 编辑器",
  please_update_unvalidated_fields: "请更新未验证的字段",
  sequence_workflow_condition_form_item_label_condition: "条件",
  sequence_workflow_condition_form_item_label_node: "节点",
  sequence_workflow_condition_form_item_label_type: "类型",
  sequence_workflow_run_test_dialog_title: "运行测试",
  sequence_workflow_run_test_dialog_submit_button: "运行",
  please_select_a_target: "请选择一个目标",
  sequence_workflow_run_test_dialog_targets: "序列目标",
  run_test: "运行测试",
};


export const sequence_detail_steps_japanese = {
  sequence_workflow_condition_add: "条件を追加",
  sequence_detail_setting_credential_primary_flag: "プライマリ",
  sequence_detail_setting_credential_primary_opeator: "プライマリに設定",
  sequence_workflow_setting_panel_reply_thread: "前のスレッドに返信",
  sequence_workflow_setting_panel_template_dialog_go_edit: "テンプレートソースで編集",
  sequence_workflow_setting_panel_edit_template_notic_dialog_title:
    "このメールはテンプレートにリンクされています",
  sequence_workflow_setting_panel_edit_template_notic_dialog_content_para:
    "この内容はテンプレートにリンクされているためロックされており、シーケンス間の一貫性が保たれています。編集するには2つのオプションがあります:",
  sequence_workflow_setting_panel_edit_template_notic_dialog_content_li_1:
    "テンプレートを編集 —— 更新はすべてのリンクされたメールに適用されます",
  sequence_workflow_setting_panel_edit_template_notic_dialog_content_li_2:
    "このメールのリンクを解除 —— 直接編集できますが、テンプレートとは同期されなくなります",
  sequence_workflow_setting_panel_unlink_template_dialog_submit_button:
    "リンク解除して編集",
  sequence_workflow_setting_panel_unlink_template_dialog_go_template_button:
    "テンプレートに移動",
  sequence_template_aside_empty_description: "ここにはまだ何もありません",
  version: "バージョン",
  sequence_workflow_template_dialog_refresh: "更新",
  sequence_workflow_template_dialog_use_template_button: "テンプレートを使用",
  sequence_workflow_template_dialog_use_template_button_copy: "コピーして貼り付け",
  sequence_workflow_template_dialog_use_template_button_link: "リンク",
  sequence_workflow_template_blank: "ここにはまだ何もありません",
  sequence_workflow_setting_panel_template_dialog_title: "テンプレート",
  sequence_workflow_setting_panel_template_placeholder: "テンプレートを選択",
  sequence_details_steps_canvas_new_version: "新しいバージョン",
  sequence_workflow_delay_minute: "0 分 | 1 分 | {count} 分",
  sequence_workflow_delay_day: "0 日 | 1 日 | {count} 日",
  sequence_workflow_delay_hour: "0 時間 | 1 時間 | {count} 時間",
  json_editor_dialog_title: "JSON エディター",
  please_update_unvalidated_fields: "未検証のフィールドを更新してください",
  sequence_workflow_condition_form_item_label_condition: "条件",
  sequence_workflow_condition_form_item_label_node: "ノード",
  sequence_workflow_condition_form_item_label_type: "タイプ",
  sequence_workflow_run_test_dialog_title: "テストを実行",
  sequence_workflow_run_test_dialog_submit_button: "実行",
  sequence_workflow_run_test_dialog_targets: "シーケンスターゲット",
  please_select_a_target: "ターゲットを選択してください",
  run_test: "テストを実行"
};

export const sequence_detail_steps_korean = {
  sequence_workflow_condition_add: "조건 추가",
  sequence_detail_setting_credential_primary_flag: "기본",
  sequence_detail_setting_credential_primary_opeator: "기본으로 설정",
  sequence_workflow_setting_panel_reply_thread: "이전 스레드에 답장",
  sequence_workflow_setting_panel_template_dialog_go_edit: "템플릿 소스에서 편집",
  sequence_workflow_setting_panel_edit_template_notic_dialog_title:
    "이 이메일은 템플릿에 연결되어 있습니다",
  sequence_workflow_setting_panel_edit_template_notic_dialog_content_para:
    "이 내용은 템플릿에 연결되어 있어 잠겨 있으며 시퀀스 간 일관성이 유지됩니다. 편집하려면 두 가지 옵션이 있습니다:",
  sequence_workflow_setting_panel_edit_template_notic_dialog_content_li_1:
    "템플릿 편집 —— 업데이트는 모든 연결된 이메일에 적용됩니다",
  sequence_workflow_setting_panel_edit_template_notic_dialog_content_li_2:
    "이 이메일 연결 해제 —— 직접 편집할 수 있지만 템플릿과 동기화되지 않습니다",
  sequence_workflow_setting_panel_unlink_template_dialog_submit_button:
    "연결 해제 후 편집",
  sequence_workflow_setting_panel_unlink_template_dialog_go_template_button:
    "템플릿으로 이동",
  sequence_template_aside_empty_description: "여기에 아직 내용이 없습니다",
  version: "버전",
  sequence_workflow_template_dialog_refresh: "새로 고침",
  sequence_workflow_template_dialog_use_template_button: "템플릿 사용",
  sequence_workflow_template_dialog_use_template_button_copy: "복사하여 붙여넣기",
  sequence_workflow_template_dialog_use_template_button_link: "링크",
  sequence_workflow_template_blank: "여기에 아직 내용이 없습니다",
  sequence_workflow_setting_panel_template_dialog_title: "템플릿",
  sequence_workflow_setting_panel_template_placeholder: "템플릿 선택",
  sequence_details_steps_canvas_new_version: "새 버전",
  sequence_workflow_delay_minute: "0분 | 1분 | {count}분",
  sequence_workflow_delay_day: "0일 | 1일 | {count}일",
  sequence_workflow_delay_hour: "0시간 | 1시간 | {count}시간",
  json_editor_dialog_title: "JSON 편집기",
  please_update_unvalidated_fields: "검증되지 않은 필드를 업데이트하세요",
  sequence_workflow_condition_form_item_label_condition: "조건",
  sequence_workflow_condition_form_item_label_node: "노드",
  sequence_workflow_condition_form_item_label_type: "유형",
  sequence_workflow_run_test_dialog_title: "테스트 실행",
  sequence_workflow_run_test_dialog_submit_button: "실행",
  sequence_workflow_run_test_dialog_targets: "시퀀스 대상",
  please_select_a_target: "대상을 선택하세요",
  run_test: "테스트 실행"
};

export const sequence_detail_steps_hindi = {
  sequence_workflow_condition_add: "शर्त जोड़ें",
  sequence_detail_setting_credential_primary_flag: "प्राथमिक",
  sequence_detail_setting_credential_primary_opeator: "प्राथमिक के रूप में सेट करें",
  sequence_workflow_setting_panel_reply_thread: "पिछले थ्रेड को जवाब दें",
  sequence_workflow_setting_panel_template_dialog_go_edit: "टेम्प्लेट स्रोत में संपादित करें",
  sequence_workflow_setting_panel_edit_template_notic_dialog_title:
    "यह ईमेल टेम्प्लेट से लिंक है",
  sequence_workflow_setting_panel_edit_template_notic_dialog_content_para:
    "यह सामग्री लॉक है क्योंकि यह टेम्प्लेट से लिंक है, जो अनुक्रमों के बीच स्थिरता सुनिश्चित करता है। संपादित करने के लिए आपके पास दो विकल्प हैं:",
  sequence_workflow_setting_panel_edit_template_notic_dialog_content_li_1:
    "टेम्प्लेट संपादित करें —— अपडेट सभी लिंक्ड ईमेल पर लागू होगा",
  sequence_workflow_setting_panel_edit_template_notic_dialog_content_li_2:
    "इस ईमेल को अनलिंक करें —— सीधे संपादित कर सकते हैं लेकिन अब टेम्प्लेट के साथ सिंक नहीं होगा",
  sequence_workflow_setting_panel_unlink_template_dialog_submit_button:
    "अनलिंक करें और संपादित करें",
  sequence_workflow_setting_panel_unlink_template_dialog_go_template_button:
    "टेम्प्लेट पर जाएं",
  sequence_template_aside_empty_description: "यहां अभी तक कुछ नहीं है",
  version: "संस्करण",
  sequence_workflow_template_dialog_refresh: "ताज़ा करें",
  sequence_workflow_template_dialog_use_template_button: "टेम्प्लेट उपयोग करें",
  sequence_workflow_template_dialog_use_template_button_copy: "कॉपी करें और पेस्ट करें",
  sequence_workflow_template_dialog_use_template_button_link: "लिंक",
  sequence_workflow_template_blank: "यहां अभी तक कुछ नहीं है",
  sequence_workflow_setting_panel_template_dialog_title: "टेम्प्लेट",
  sequence_workflow_setting_panel_template_placeholder: "टेम्प्लेट चुनें",
  sequence_details_steps_canvas_new_version: "नया संस्करण",
  sequence_workflow_delay_minute: "0 मिनट | 1 मिनट | {count} मिनट",
  sequence_workflow_delay_day: "0 दिन | 1 दिन | {count} दिन",
  sequence_workflow_delay_hour: "0 घंटे | 1 घंटे | {count} घंटे",
  json_editor_dialog_title: "JSON संपादक",
  please_update_unvalidated_fields: "असत्यापित फ़ील्ड्स को अपडेट करें",
  sequence_workflow_condition_form_item_label_condition: "शर्त",
  sequence_workflow_condition_form_item_label_node: "नोड",
  sequence_workflow_condition_form_item_label_type: "प्रकार",
  sequence_workflow_run_test_dialog_title: "टेस्ट चलाएं",
  sequence_workflow_run_test_dialog_submit_button: "चलाएं",
  sequence_workflow_run_test_dialog_targets: "अनुक्रम लक्ष्य",
  please_select_a_target: "कृपया एक लक्ष्य चुनें",
  run_test: "टेस्ट चलाएं"
};